import axios from 'axios'
import config from '@/config'
import { store } from '@/store/store'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

export default {
  getUserStates(params) {
    return instance().get('/user-state-list', { params })
  }
}



// WEBPACK FOOTER //
// ./src/api/user-state.js